import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface UseEffectiveSeatReservationResult {
  seatReserved: boolean;
  seat: number;
  stack: number;
}

export const useSeatReservation = (
  propSeatReserved: boolean,
  propSeat: number,
  propStack: number,
): UseEffectiveSeatReservationResult => {
  const location = useLocation();
  const [seatReserved, setSeatReserved] = useState(propSeatReserved);
  const [seat, setSeat] = useState<number>(propSeat);
  const [stack, setStack] = useState<number>(propStack);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const seatParam = searchParams.get('seat');
    const stackParam = searchParams.get('stack');

    const isSeatReservedFromParams = !!seatParam && !!stackParam;

    setSeatReserved(propSeatReserved || isSeatReservedFromParams);
    if (isSeatReservedFromParams) {
      if (seatParam) {
        setSeat(parseInt(seatParam));
      }
      if (stackParam) {
        setStack(parseInt(stackParam));
      }
    } else {
      setSeat(propSeat);
      setStack(propStack);
    }
  }, [location.search, propSeatReserved]);

  return { seatReserved, seat, stack };
};
